import React, { useState, useContext, useEffect } from "react"
import { useTranslation } from "react-i18next"
import DesktopHeaderPopup from './DesktopHeaderPopup'
import { Link } from "gatsby"
import BasicLink from "../../basics/Link"
import { router } from "../../../utility/router"
import { PageContext } from "../Page"
import { getHeaderTheme } from "./headerUtility"
import cx from "classnames"

import Arrow from '../../../assets/icons/down-arrow-header.svg'
import SearchIcon from '../../../assets/icons/search.svg'
import SearchNegativeIcon from '../../../assets/icons/search-negative.svg'
import FabrickLogo from '../../../assets/logos/fabrick-logo.svg'
import { LanguageSelect } from "../../components/LanguageSelect"

const DesktopHeader = ({ type = 'full', theme, isTransparent, isTopOfThePage, topPosition, shadow, logoUrl }) => {
  // Indica il menu che è aperto in questo momento
  const [currentMenu, setCurrentMenu] = useState('')
  // Come currentMenu, ma non diventa '' quando chiudo il menu. Quindi tiene traccia di quale menu abbiamo appena chiuso. Serve per l'animazione di chiusura
  const [justOpenedMenu, setJustOpenedMenu] = useState('')
  // Questo è l'ID del setTimeout() che si occupa di chiudere in automatico il menu se porti il mouse fuori.
  // var closeMenuTimerID

  // const timeToCloseMenuAutomatically = 250
  const context = useContext(PageContext)
  const fixed = context.layout.headerFixed
  const currentTheme = getHeaderTheme(theme, isTransparent, isTopOfThePage, currentMenu !== '')
  const [t] = useTranslation("layout")

  useEffect(() => {
    // toggleBodyScrolling(true)
    setCurrentMenu('')
  }, [])

  useEffect(() => {
    window.onscroll = () => {
      if (currentMenu !== '') {
        changeOpenedMenu('')
      }
    }
    return () => (window.onscroll = null)
  })

  function changeOpenedMenu(newMenu) {
    setCurrentMenu(newMenu)
    if (newMenu !== '') {
      setJustOpenedMenu(newMenu)
      // toggleBodyScrolling(false)
    } else {
      // toggleBodyScrolling(true)
    }
  }

  // function toggleBodyScrolling(allow) {
  //   var html = document.querySelector("html")
  //   html.style.overflowY = allow ? "" : 'hidden'
  // }

  const handleNavlinkClick = (menuToOpen) => {
    // console.log("-------")
    // console.log("justOpenedMenu: " + justOpenedMenu)
    // console.log("menuToOpen: " + menuToOpen)
    // console.log("currentMenu: " + currentMenu)
    if (menuToOpen === currentMenu) {
      changeOpenedMenu('')
    } else {
      changeOpenedMenu(menuToOpen)
    }
  }

  const handleClickOutsideMenu = () => {
    changeOpenedMenu('')
  }

  //* #region Timer chiusura header
  // function restartCloseMenuTimer() {
  //   // console.log('restarted timer')
  //   clearTimeout(closeMenuTimerID)
  //   const newTimeoutID = setTimeout(() => triggerTimer(), timeToCloseMenuAutomatically)
  //   closeMenuTimerID = newTimeoutID
  // }
  // function DestroyCloseMenuTimer() {
  //   // console.log('destroyed timer')
  //   clearTimeout(closeMenuTimerID)
  // }
  // const triggerTimer = () => {
  //   changeOpenedMenu('')
  // }
  //* #endregion Timer chiusura header

  //* #region Gestione hover di link e menu  
  // const handleMouseEnterNavlink = (menuToOpen) => {
  //   // Sono entrato in un navlink, distruggo il timer
  //   DestroyCloseMenuTimer()
  //   changeOpenedMenu(menuToOpen)
  // }
  // const handleMouseLeaveNavlink = () => {
  //   // Sono uscito da un navlink, restarto il timer
  //   restartCloseMenuTimer()
  // }
  // const handleMouseEnterMenu = () => {
  //   // Sono entrato nel menu, distruggo il timer
  //   DestroyCloseMenuTimer()
  // }
  // const handleMouseLeaveMenu = () => {
  //   // Sono uscito dal menu, restarto il timer
  //   restartCloseMenuTimer()
  // }
  //* #endregion Gestione hover di link e menu

  return <div className={cx(`header hidden header-mobile:flex ${topPosition} ${shadow} ${currentTheme.bgColor} ${currentTheme.transitions} w-full h-header flex items-center px-container-mobile header-normal:px-container-desktop z-[100]`, { "sticky": !fixed, "fixed": fixed })}>
    <BasicLink to={logoUrl}>
      <FabrickLogo className={`w-[100px] h-[24px] min-w-[100px] ${currentTheme.transitions} ${currentTheme.vectorFill}`} />
    </BasicLink>

    {type === 'full' && <div className="w-full flex justify-between items-center select-none ml-1">
      <div className="flex">
        <MenuButton menuName="products"
          label={t('header.products')}
          currentMenu={currentMenu}
          onClick={handleNavlinkClick}
          // onMouseEnter={handleMouseEnterNavlink} onMouseLeave={handleMouseLeaveNavlink}
          textColor={currentTheme.textColor}
          themeTransitionClasses={currentTheme.transitions}
          vectorStroke={currentTheme.vectorStroke}
        />

        <MenuButton menuName="industry"
          label={t('header.industry')}
          currentMenu={currentMenu}
          onClick={handleNavlinkClick}
          // onMouseEnter={handleMouseEnterNavlink} onMouseLeave={handleMouseLeaveNavlink}
          textColor={currentTheme.textColor}
          themeTransitionClasses={currentTheme.transitions}
          vectorStroke={currentTheme.vectorStroke}
        />

        <MenuButton menuName="insights"
          label={t('header.insights')}
          currentMenu={currentMenu}
          onClick={handleNavlinkClick}
          // onMouseEnter={handleMouseEnterNavlink} onMouseLeave={handleMouseLeaveNavlink}
          textColor={currentTheme.textColor}
          themeTransitionClasses={currentTheme.transitions}
          vectorStroke={currentTheme.vectorStroke}
        />

        <MenuButton menuName="developers"
          label={t('header.developers')}
          currentMenu={currentMenu}
          onClick={handleNavlinkClick}
          // onMouseEnter={handleMouseEnterNavlink} onMouseLeave={handleMouseLeaveNavlink}
          textColor={currentTheme.textColor}
          themeTransitionClasses={currentTheme.transitions}
          vectorStroke={currentTheme.vectorStroke}
        />

        {/* <MenuButton menuName="support"
          label={t('header.support')}
          currentMenu={currentMenu}
          onClick={handleNavlinkClick}
          // onMouseEnter={handleMouseEnterNavlink} onMouseLeave={handleMouseLeaveNavlink}
          textColor={currentTheme.textColor}
          themeTransitionClasses={currentTheme.transitions}
          vectorStroke={currentTheme.vectorStroke}
        /> */}

        <Link
          to={router('support.customer-support', context.folder)}
          className={`${currentTheme.textColor} ${currentTheme.transitions} text-link-unstyled font-medium body whitespace-nowrap p-1`}
        >
          {t('header.support')}
        </Link>

        <MenuButton menuName="about-fabrick"
          label={t('header.aboutFabrick')}
          currentMenu={currentMenu}
          onClick={handleNavlinkClick}
          // onMouseEnter={handleMouseEnterNavlink} onMouseLeave={handleMouseLeaveNavlink}
          textColor={currentTheme.textColor}
          themeTransitionClasses={currentTheme.transitions}
          vectorStroke={currentTheme.vectorStroke}
        />

        <Link
          to={router('contacts', context.folder)}
          className={`${currentTheme.textColor} ${currentTheme.transitions} text-link-unstyled font-medium body whitespace-nowrap p-1 header-normal:px-1.5`}
        >
          {t('header.contacts')}
        </Link>

      </div>


      <DesktopHeaderPopup
        currentMenu={currentMenu}
        justOpenedMenu={justOpenedMenu}
        onClickOutside={handleClickOutsideMenu}
        closeMenuFunction={() => { changeOpenedMenu('') }}
      // onMouseEnter={handleMouseEnterMenu}
      // onMouseLeave={handleMouseLeaveMenu}
      />

      <div className="flex items-center">
        <Link to={router('search', context.folder)} className="p-2">
          {currentTheme.theme === "dark" ? <SearchNegativeIcon /> : <SearchIcon />}
        </Link>
        <div className="hidden header-normal:block">
          <LanguageSelect negative={currentTheme.theme === 'dark'} />
        </div>
        <BasicLink to={router("login", context.folder)} button medium className="px-3">{t("header.login")}</BasicLink>
      </div>
    </div>}
  </div>
}

const MenuButton = ({ label, menuName, currentMenu, onClick, onMouseEnter, onMouseLeave, textColor, themeTransitionClasses, vectorStroke }) => {
  const isOpen = currentMenu === menuName

  return <div
    className={`navlink flex items-center font-medium body cursor-pointer whitespace-nowrap px-1 header-normal:px-1.5`}
    onClick={() => onClick(menuName)}
  // onMouseEnter={() => onMouseEnter(menuName)}
  // onMouseLeave={() => onMouseLeave(menuName)}
  >
    <div className="flex items-center">
      <span className={`${textColor} ${themeTransitionClasses}`}>{label}</span>
      <Arrow className={`arrow ${isOpen ? 'open' : ''} ${vectorStroke} ${themeTransitionClasses} ml-0 header-normal:ml-0.25 w-[16px] h-[16px]`} />
    </div>
  </div>
}

export default DesktopHeader